import React, { useRef } from "react"
import Button from "@src/components/core-button"
import Spinner from "@src/components/core-spinner"
import { UserContext } from "@src/context/user-context"
import { useForm, FormProvider } from "react-hook-form"
import { validateEmail } from "@src/utils/validators"
import { FormActions } from "../../reusable/forms/auth-forms.styled"
import styled from "styled-components"
import Input from "@src/components/reusable/forms/input-v2"
import InputPassword from "@src/components/reusable/forms/input-password"

const FormActionsStyled = styled(FormActions)`
  width: 100%;
  .link-cta {
    color: ${props => props.theme.secondary900};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    a {
      color: ${props => props.theme.secondary400} !important;
      font-size: 16px !important;
      font-style: normal;
      font-weight: 400 !important;
      line-height: 24px;
      letter-spacing: 0.08px;
      text-decoration-line: underline !important;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
    }
  }
`

const Title = styled.div`
  color: ${props => props.theme.secondary700};
  text-align: center;
  font-size: 32px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 44px !important;
  letter-spacing: 0.5px;
  margin-bottom: 16px !important;
  margin-top: 32px;
`

const SubTitle = styled.div`
  color: ${props => props.theme.secondary700};
  margin-bottom: 32px;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`

const FormLogin = ({
  status,
  setStatus,
  handleModalClose,
  emailContext,
  children,
}) => {
  const methods = useForm({
    defaultValues: {
      email: emailContext,
    },
  })

  const formRef = useRef()

  const handleProgrammaticSubmit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true }),
      )
    }
  }

  return (
    <FormProvider {...methods}>
      <Title className="h2">
        Login to your <span className="underline2">account</span>
      </Title>
      <SubTitle className="center">Start your adventure today.</SubTitle>
      <UserContext.Consumer>
        {({ signin }) => {
          const handleSubmit = async ({ email, password }) => {
            setStatus({ ...status, pending: true })
            await signin(email, password)
              .then(() => {
                setStatus({
                  success: true,
                  pending: false,
                  formMessage: null,
                })
              })
              .catch(error => {
                setStatus({
                  success: false,
                  pending: false,
                  formMessage: error,
                })
              })
          }
          return (
            <>
              {status.success ? null : (
                <Form
                  ref={formRef}
                  onSubmit={methods.handleSubmit(handleSubmit)}
                >
                  <Input
                    name="email"
                    label="Email"
                    icon="/icons/email.svg"
                    placeholder="Email"
                    validate={validateEmail("Incorrect email")}
                    className="full-width left"
                  />
                  <InputPassword label="Password" name="password" />
                </Form>
              )}
              <FormActionsStyled>
                {status.formMessage && (
                  <p className="form-error">{status.formMessage}</p>
                )}
                {status.success ? (
                  <Button color="dark" onClick={handleModalClose}>
                    Start Browsing
                  </Button>
                ) : (
                  <Button
                    color="dark"
                    disabled={status.pending}
                    onClick={handleProgrammaticSubmit}
                  >
                    Login{" "}
                    {status.pending && <Spinner color="white" size="sm" />}
                  </Button>
                )}
                <br />
                {status.success ? undefined : children}
              </FormActionsStyled>
            </>
          )
        }}
      </UserContext.Consumer>
    </FormProvider>
  )
}

export default FormLogin
